<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="ch00_fm02_alive"><a id="page_ii"></a><strong><span class="smallcaps">OTHER BOOKS BY STAN DAVIS</span></strong></p>
<p class="centerm"><em>It’s Alive! The Convergence of<br/>Information, Biology and Business</em><br/><span class="smallcaps">WITH CHRISTOPHER MEYER</span></p>
<p class="centerm"><em>Lessons from the Future</em></p>
<p class="centerm"><em>Future Wealth</em><br/><span class="smallcaps">WITH CHRISTOPHER MEYER</span></p>
<p class="centerm"><em>Blur</em><br/><span class="smallcaps">WITH CHRISTOPHER MEYER</span></p>
<p class="centerm"><em>The Monster Under the Bed</em><br/><span class="smallcaps">WITH JIM BOTKIN</span></p>
<p class="centerm"><em>2020 Vision</em><br/><span class="smallcaps">WITH BILL DAVIDSON</span></p>
<p class="centerm"><em>Future Perfect</em></p>
<p class="centerm"><em>Managing Corporate Culture</em></p>
<p class="centerm"><em>Managing &amp; Organizing Multinational Corporations</em></p>
<p class="centerm"><em>Matrix</em><br/><span class="smallcaps">WITH PAUL LAWRENCE</span></p>
<p class="centerm"><em>Workers &amp; Managers in Latin America</em><br/><span class="smallcaps">WITH LOUIS WOLF GOODMAN</span></p>
<p class="centerm"><em>Comparative Management</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_alive.vue?42863650